import { render, staticRenderFns } from "./NewDistrict.vue?vue&type=template&id=1d38cfb3&scoped=true"
import script from "./NewDistrict.vue?vue&type=script&lang=js"
export * from "./NewDistrict.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d38cfb3",
  null
  
)

export default component.exports